import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnTaxonomyCategoryBasicInfoComponent({ domains, handleInnerFormChange, selectedCategory, parentCategory }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedCategory?.Name}
            />

            <InputContainer

              label="Sub Category"

              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsSubCategory',

                )
              }}
              type="checkbox"
              value={selectedCategory?.IsSubCategory}
            />
            {selectedCategory?.IsSubCategory === true &&
              <InputContainer
                label="Parent Category"
                labelField="Name"
                list={parentCategory}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ParentCategoryId'
                  );
                }}
                optionName="Choose Parent Category"
                type="select"
                value={selectedCategory?.ParentCategoryId}
                valueField="GlobalDBNCategoryId"
              />
            }
            <InputContainer

              label="Code"

              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code'
                );
              }}
              type="text"
              value={selectedCategory?.Code}
            />

            <InputContainer
              label="Domain Name"
              labelField="Name"
              list={domains}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'GlobalDBNDomainId'
                );
              }}
              optionName="Choose Domain"
              type="select"
              value={selectedCategory?.GlobalDBNDomainId}
              valueField="GlobalDBNDomainId"
            />

          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}